export enum InvoiceEnums {

  //Estados
  abierta = 1,
  cerrada = 2,
  impresa = 3,
  pagada = 4,
  anulada = 5,

  //Operación
  contado = 1,
  credito = 2,
  contadoAsterisco = 3,

  //Tipo Cartera
  corriente = 1,
  dudosoCobro = 2,
  canje = 3,

  //Metodo de pago
  efectivo = 1,
  tarjetoCredito = 2,
  tarjetaDebito = 3,
  consignacionBanco = 4,
  cheque = 5,
  acuerdoMutuo = 6
}